import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=3122993f&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=ts"
export * from "./QuickActions.vue?vue&type=script&lang=ts"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=3122993f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122993f",
  null
  
)

export default component.exports